import { motion } from "framer-motion";

// Subtle animated blueprint scan lines for the industrial hero backdrop.
export const BlueprintLines = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="blueprint-lines">
    <motion.div
      className="absolute left-0 right-0 h-px bg-gradient-to-r from-transparent via-weld-glow/40 to-transparent"
      initial={{ top: "0%" }}
      animate={{ top: ["0%", "100%"] }}
      transition={{ duration: 9, repeat: Infinity, ease: "linear" }}
    />
    <motion.div
      className="absolute top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-weld/30 to-transparent"
      initial={{ left: "15%" }}
      animate={{ left: ["15%", "85%", "15%"] }}
      transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
    />
    <motion.div
      className="absolute left-0 right-0 h-px bg-gradient-to-r from-transparent via-weld/20 to-transparent"
      initial={{ top: "70%" }}
      animate={{ top: ["70%", "20%", "70%"] }}
      transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
    />
  </div>
);
